import { Injectable, Injector } from '@angular/core';
import { SynchronizationServiceBase } from './synchronization-service-base';
import { SynchronizationEntity } from './synchronization-entity';
import { ShiftRepository } from '../local-db/repositories/shift-repository';

@Injectable({ providedIn: 'root' })
export class ShiftSyncService extends SynchronizationServiceBase {
    constructor(
        injector: Injector,
        private readonly _shiftRepo: ShiftRepository
    ) {
        super(injector, SynchronizationEntity.Shifts);
    }

    public async synchronize(): Promise<void> {
        await this._shiftRepo.refreshShifts();
    }
}
